import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import NotificationList from "../../features/notification/components/NotificationList/NotificationList";
import { useUser } from "../../hooks/useUser";
import { aunjaiBackendService } from "../../services/aunjai-backend.service";
import HeaderComponent from "../Header/HeaderComponent";
import styles from "./style.module.css";
import Button from "../../components/ui/Button/Button";

const LIMIT = 10;

const NotificationsPage = () => {
  const { t } = useTranslation("notification");
  const { userData } = useUser();
  const [notifications, setNotifications] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    const fetchNotifications = async () => {
      if (!userData?.id) return;
      setLoading(true);
      const { data, total: totalNotifications } =
        await aunjaiBackendService.getLineNotificationHistories({
          borrowerId: userData?.id,
          limit: LIMIT,
          page,
        });

      setNotifications((prev) => [...prev, ...(data || [])]);
      setTotal(totalNotifications || 0);
      await aunjaiBackendService.updateNotificationMarkAsRead({
        borrowerId: userData?.id,
      });
      setLoading(false);
      setHasMore(data.length === LIMIT);
    };

    fetchNotifications();
  }, [userData?.id, page]);

  return (
    <>
      <HeaderComponent
        title={t("allNotifications")}
        onBack={() => navigate("/")}
      />
      <div className={styles.container}>
        <p style={{ marginBottom: 10 }} className={styles.subtitle}>
          {total} {t("notification")}
        </p>

        <div className={styles.content}>
          <NotificationList
            notifications={notifications}
            notificationCardVariant=""
            gap="0"
          />
          {total > 0 && (
            <div className={styles.loadMore}>
              <Button
                onClick={() => setPage(page + 1)}
                disabled={!hasMore || loading}
              >
                {t("loadMore")}
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default NotificationsPage;
